<template>
  <div class="tile is-parent is-vertical">
    <div class="tile is-child">
      <div class>
        <div class>
          <section class>
            <section id="entity-content" class>
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification formbox">
                  <b-tabs>
                    <b-tab-item label="Meu Perfil">
                      <div>
                        <img src="../../assets/images/icon-color/user.svg" class="profile-photo" />

                        <span class="profile-name-a">{{ usuario.name }}</span>
                        <span class="profile-job-a">{{ usuario.cargo }}</span>

                        <div class="div-school">
                          <img src="../../assets/images/icon-color/school-icon.svg" />
                          <span class>{{ usuario.vinculo }}</span>
                        </div>
                        <div class="div-member">
                          <img src="../../assets/images/icon-color/id-card.svg" />
                          <span
                            class
                          >Membro desde {{ formatData(usuario.matriculado, 'DD/MM/YYYY') }}</span>
                        </div>
                      </div>
                      <div class="profile-infos-c">
                        <hr class="hr-text" data-content="Dados Pessoais" />
                        <ul>
                          <li>
                            E-Mail:
                            <span class="profile-infos-span">{{ usuario.email}}</span>
                          </li>
                          <li>
                            Telefone/Celular:
                            <span class="profile-infos-span">{{ usuario.telefone }}</span>
                          </li>
                          <li>
                            Data de Nascimento:
                            <span
                              class="profile-infos-span"
                            >{{ formatData(usuario.nascimento, 'DD/MM/YYYY') }}</span>
                          </li>
                          <li>
                            Senha:
                            <a class="profile-infos-span profile-infos-link">Alterar Senha</a>
                          </li>
                        </ul>
                      </div>
                    </b-tab-item>

                    <b-tab-item label="Dados Profissionais">
                      <div class="div-tab-item">
                        <div class="profile-dados-p">
                          <hr class="hr-text" data-content="Dados Bancários" />
                          <ul>
                            <li>
                              Titular da Conta
                              <span
                                class="profile-infos-span"
                              >{{ usuario.name + " " + usuario.sobrenome}}</span>
                            </li>
                            <li>
                              CPF
                              <span class="profile-infos-span">{{ usuario.cpf }}</span>
                            </li>
                            <li>
                              Banco
                              <span class="profile-infos-span">{{ usuario.banco }}</span>
                            </li>
                            <li>
                              Agência
                              <span class="profile-infos-span">{{ usuario.agencia }}</span>
                            </li>
                            <li>
                              Conta Corrente
                              <span class="profile-infos-span">{{ usuario.conta }}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <div class="profile-curriculo">
                          <hr class="hr-text" data-content="Currículo" />
                          <ul>
                            <li>
                              Formação
                              <span class="profile-infos-span">XXXX-XXXX - XXX</span>
                            </li>
                            <li>
                              Expe. Profissional
                              <span class="profile-infos-span">XXXX-XXXX - XXX</span>
                            </li>
                            <li>
                              Currículo Anexado
                              <span class="profile-infos-span">Curriculum.pdf</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <div class="profile-time">
                          <hr class="hr-text" data-content="Disponibilidade de Horas" />
                          <ul>
                            <li>
                              Segunda-Feira
                              <span class="profile-infos-span">{{ usuario.segunda }}</span>
                            </li>
                            <li>
                              Terça-Feira
                              <span class="profile-infos-span">{{ usuario.terca }}</span>
                            </li>
                            <li>
                              Quarta-Feira
                              <span class="profile-infos-span">{{ usuario.quarta }}</span>
                            </li>
                            <li>
                              Quinta-Feira
                              <span class="profile-infos-span">{{ usuario.quinta }}</span>
                            </li>
                            <li>
                              Sexta-Feira
                              <span class="profile-infos-span">{{ usuario.sexta }}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </b-tab-item>

                    <b-tab-item label="Meus Créditos">
                      <div class="div-tab-item">
                        <div class="profile-my-cred">
                          <ul>
                            <li>
                              Redações Corrigidas
                              <span
                                class="profile-infos-span"
                              >{{ usuario.total }}</span>
                            </li>
                            <li>
                              Créditos Pagos
                              <span class="profile-infos-span">{{ usuario.pago }}</span>
                            </li>
                            <li>
                              Créditos a Receber
                              <span
                                class="profile-infos-span"
                              >{{ usuario.receber }}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </b-tab-item>
                  </b-tabs>
                </article>
              </div>
            </section>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mostrar: true,
      escolas: []
    };
  },
  props: ["usuario"]
};
</script>